import type { PriceList } from 'www/vue_components/common/DoctorPageLpuList/types'

function getWorkplaceNonNullPrices(priceList: PriceList) {
  return Object.entries(priceList)
    .filter(([key, value]) => (key !== 'priceClub' && typeof value === 'number'))
    .map(([, value]) => value) as number[]
}

export default getWorkplaceNonNullPrices
